import { render, staticRenderFns } from "./detailVideo.vue?vue&type=template&id=1da4209e&scoped=true&"
import script from "./detailVideo.vue?vue&type=script&lang=js&"
export * from "./detailVideo.vue?vue&type=script&lang=js&"
import style0 from "./detailVideo.vue?vue&type=style&index=0&id=1da4209e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4209e",
  null
  
)

export default component.exports